import { createCustomEvent } from './common';

export const applyCdnUrl = filePath => {
	return CdnDomain + filePath;
};

export const dispatchAlert = (text, modalId = 'alert-modal') => {
	const modalEle = document.getElementById(modalId);
	modalEle && modalEle.dispatchEvent(createCustomEvent('showAlert', { text }));
};

export const displayRedirectAlert = () => {
	const currentUrl = new URL(location.href);
	const alertMsg = currentUrl.searchParams.get('alertMsg');

	if (alertMsg) {
		history.replaceState(null, null, location.pathname);
		dispatchAlert(alertMsg);
	}
};